import React, { useState, useEffect } from 'react';

function MissionBrief({ mission, onBegin }) {
  const [visibleLines, setVisibleLines] = useState(0);
  const [showButton, setShowButton] = useState(false);
  const lines = mission.briefing;

  useEffect(() => {
    if (visibleLines < lines.length) {
      const delay = lines[visibleLines] === '' ? 250 : 500;
      const timer = setTimeout(() => setVisibleLines(v => v + 1), delay);
      return () => clearTimeout(timer);
    } else {
      const timer = setTimeout(() => setShowButton(true), 600);
      return () => clearTimeout(timer);
    }
  }, [visibleLines, lines]);

  const handleSkip = () => {
    setVisibleLines(lines.length);
    setShowButton(true);
  };

  return (
    <div className="briefing-screen">
      <div className="briefing-header">
        <span className="briefing-label">MISSION BRIEFING</span>
        <span className="briefing-module">{mission.moduleId}: {mission.moduleName}</span>
      </div>

      <div className="briefing-content">
        {lines.slice(0, visibleLines).map((line, i) => (
          <p
            key={i}
            className={`briefing-line ${line === '' ? 'briefing-spacer' : ''} ${i === visibleLines - 1 ? 'briefing-line-new' : ''}`}
          >
            {line}
          </p>
        ))}
        {visibleLines < lines.length && (
          <span className="briefing-cursor">&#x2588;</span>
        )}
      </div>

      <div className="briefing-footer">
        {showButton ? (
          <button className="btn-primary btn-begin" onClick={onBegin}>
            BEGIN MISSION
          </button>
        ) : (
          <button className="btn-skip" onClick={handleSkip}>
            SKIP &gt;&gt;
          </button>
        )}
      </div>

      <div className="briefing-scene">
        <div className="briefing-scene-label">SCENE</div>
        <div className="briefing-scene-text">{mission.scene.environment}</div>
        <div className="briefing-objective-label">OBJECTIVE</div>
        <div className="briefing-objective-text">{mission.scene.objective}</div>
      </div>
    </div>
  );
}

export default MissionBrief;
